import styled from "styled-components";

const TimeConfigMenuWrapper = styled.div`
  position: absolute;
  /* right: 0; */
  padding: 16px;
  display: flex;
  gap: 8px;
`;

export { TimeConfigMenuWrapper };
